const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001'

export const createTournament = async (format) => {
  const response = await fetch(`${API_URL}/api/tournaments`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ format }),
  })
  const data = await response.json()
  if (!response.ok) throw new Error(data.message || 'Não foi possível criar o torneio.')
  return data
}

export const fetchTournamentState = async (id) => {
  const response = await fetch(`${API_URL}/api/tournaments/${id}/state`)
  if (!response.ok) throw new Error('Torneio não encontrado.')
  return response.json()
}

export const setTournamentTeams = async (id, masterToken, teams) => {
  const response = await fetch(`${API_URL}/api/tournaments/${id}/teams`, {
    method: 'POST',
    headers: { 'x-master-token': masterToken, 'Content-Type': 'application/json' },
    body: JSON.stringify({ teams }),
  })
  const data = await response.json()
  if (!response.ok) throw new Error(data.message || 'Não foi possível salvar os times.')
  return data
}

export const generateTournamentBracket = async (id, masterToken, options) => {
  const response = await fetch(`${API_URL}/api/tournaments/${id}/generate`, {
    method: 'POST',
    headers: { 'x-master-token': masterToken, 'Content-Type': 'application/json' },
    body: JSON.stringify(options || {}),
  })
  const data = await response.json()
  if (!response.ok) throw new Error(data.message || 'Não foi possível gerar os confrontos.')
  return data
}

export const recordTournamentResult = async (id, masterToken, matchId, scoreA, scoreB) => {
  const response = await fetch(`${API_URL}/api/tournaments/${id}/matches/${matchId}/result`, {
    method: 'POST',
    headers: { 'x-master-token': masterToken, 'Content-Type': 'application/json' },
    body: JSON.stringify({ scoreA, scoreB }),
  })
  const data = await response.json()
  if (!response.ok) throw new Error(data.message || 'Não foi possível registrar o placar.')
  return data
}

export const tournamentStreamUrl = (id) => `${API_URL}/api/tournaments/${id}/stream`

export const tournamentJoinUrl = (id) => `${window.location.origin}/ferramentas/campeonato-ao-vivo/${id}`
